module.exports = __webpack_public_path__ + "static/media/arrow-blue.cfbbf155.svg";